import React from "react";
import { Form, Input } from "antd";

const BodegasForm = ({ form }) => {
  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="nombre"
        label="Nombre de la Bodega"
        rules={[{ required: true, message: "Por favor ingresa el nombre de la bodega" }]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default BodegasForm;